import { ISearchBarParameters } from "./searchbar-parameters";
import { API_METHODS } from "./type-models";

/**
 * Base request error class
 */
export class RequestError extends Error {

    public message      : string;
    public errorCode    : number;
    public statusCode   : number;
    public serverErrors : any[] = [];

    constructor(data: any, status: number, ...params: any[]) {
        super(...params);
        this.message = data.message;
        this.errorCode = data.code;
        this.statusCode = status;
        this.serverErrors = params;
    }
}

/**
 * Required properties for a basic saga API request
 */
export class BaseSagaRequest {
    public successAction    : string = '';
    public failAction       : string = '';
    public navigate         : string = '';
    public url              : string = '';
    public verb             : API_METHODS = 'GET';
}

/**
 * GET request
 */
export class GetRequest extends BaseSagaRequest { 
    public type : any;

    constructor() {
        super();
        this.verb = 'GET';
    }
}

/**
 * POST request
 */
export class PostRequest extends BaseSagaRequest {    
    public data : any;

    constructor() {
        super();
        this.verb = 'POST';
    }
}

/**
 * PUT request
 */
export class PutRequest extends BaseSagaRequest {
    public data: any;
    
    constructor() {
        super();
        this.verb = 'PUT';
    }
}

/**
 * DELETE request
 */
export class DeleteRequest extends BaseSagaRequest {
    public rowVersion : string = '';
    
    constructor() {
        super();
        this.verb = 'DELETE';
    }
}

/**
 * Search result request
 */
export class PagedResultRequest extends GetRequest {
    public searchParams : ISearchBarParameters|undefined = undefined;

    constructor() {
        super();
        this.verb = 'GET';
    }
}
